import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import ReactPaginate from 'react-paginate';
import { push } from 'react-router-redux';
import Search from '../../../components/search/search';
import AllFeed from '../../../components/all_feed/all_feed';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import loadData from './search_page_state_manager';

// eslint-disable-next-line react/prefer-stateless-function
class SearchPage extends Component {
  static loadData(store) {
    return loadData(store);
  }

  constructor(props) {
    super(props);

    this.renderSearch = this.renderSearch.bind(this);
    this.renderAllFeed = this.renderAllFeed.bind(this);
    this.onPaginateClick = this.onPaginateClick.bind(this);
  }

  onPaginateClick(data) {
    const { search } = this.props;
    const query = get(search, 'data.query.queryString');
    const page = data.selected;
    const url = `/search/${query}/${page + 1}`;
    this.props.nextPage(url);
  }

  renderResultBlock(searchResults, searchTerm) {
    return (
      <div className="search__content">
        {searchTerm ? (
          <Search modifier="search-page" skin="dark" searchTerm={searchTerm} />
        ) : null}
        <div className="search-results__meta">
          <h2
            className={`search-results__count search-results__count--${
              searchTerm ? 'top' : 'bottom'
            }`}
          >
            {searchResults} results
          </h2>
          {searchResults >= 10 ? this.renderPagination(searchTerm) : null}
        </div>
      </div>
    );
  }

  renderPagination(searchTerm) {
    const { search } = this.props;

    return (
      <ReactPaginate
        forcePage={get(search, 'data.paging.currPage') - 1}
        onPageChange={this.onPaginateClick}
        pageCount={get(search, 'data.paging.totalPages')}
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        previousLabel="Prev"
        nextLabel="Next"
        breakLabel="..."
        containerClassName={`pagination pagination--${
          searchTerm ? 'top' : 'bottom'
        }`}
        pageClassName="pagination__page"
        activeClassName="pagination__page pagination__page--active"
        previousClassName="pagination__page pagination__page--prev"
        nextClassName="pagination__page pagination__page--next"
        breakClassName="pagination__page pagination__page--break"
        pageLinkClassName="pagination__link"
        previousLinkClassName="pagination__link"
        nextLinkClassName="pagination__link"
        disabledClassName="pagination__link--disabled"
      />
    );
  }

  renderSearch(searchTerm, searchResults, entry, config, combinedAdModel) {
    return (
      <section className="search__wrapper">
        {this.renderResultBlock(searchResults, searchTerm)}
        <AllFeed
          adModel={combinedAdModel}
          stories={entry}
          currentSite="fastcompany"
          config={config}
          hasSlug={false}
          search={true}
          disableMore={true}
        />
        {this.renderResultBlock(searchResults)}
      </section>
    );
  }

  renderAllFeed(searchTerm, allFeed, config, combinedAdModel) {
    return (
      <section className="search__wrapper">
        <div className="search__content">
          <Search modifier="search-page" skin="dark" searchTerm={searchTerm} />
          <div className="search-results__meta">
            <h2 className="search-results__count search-results__count--none">
              No results were found, but please enjoy these suggestions:
            </h2>
          </div>
        </div>
        <AllFeed
          adModel={combinedAdModel}
          stories={allFeed}
          currentSite="fastcompany"
          config={config}
          hasSlug={false}
          disableMore={true}
        />
      </section>
    );
  }

  render() {
    const { config, searchPage, search, allFeed } = this.props;

    if (get(searchPage, 'error') === true) {
      return (
        <section className="search">
          <NotFound />
        </section>
      );
    }

    if (get(searchPage, 'isLoading') === true) {
      return (
        <section className="search">
          <LoadingSpinner />
        </section>
      );
    }

    const entry = get(search, 'data.entry') || [];
    const adData = get(searchPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const searchResults = get(search, 'data.paging.totalItems');
    const searchTerm = get(search, 'data.query.queryString');

    return (
      <section className="search">
        {get(entry, 'length')
          ? this.renderSearch(
              searchTerm,
              searchResults,
              entry,
              config,
              combinedAdModel
            )
          : this.renderAllFeed(searchTerm, allFeed, config, combinedAdModel)}

        <div className="search-results__bottom-ad">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_2"
            region="searchbottom"
          />
          <Ad
            {...combinedAdModel}
            name="mobilerectangle_2"
            region="searchbottom"
          />
        </div>
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    nextPage(url) {
      dispatch(push(url));
    }
  };
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    search: state.search || {},
    allFeed: get(state, 'allFeed.data.posts') || [],
    searchPage: state.searchPage || {
      ads: {
        baseConfig: {}
      }
    }
  };
}

SearchPage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  searchPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    searchTerm: PropTypes.string
  }).isRequired,
  allFeed: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  search: PropTypes.shape({}).isRequired,
  nextPage: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
